module.exports = __webpack_public_path__ + "static/media/Frame 6.a9f05611.png";